import React, { forwardRef } from 'react';
import MuiPaper, { PaperProps as MuiPaperProps } from '@mui/material/Paper';
import { BpDesignSystem } from '../../types';

export type PaperProps = BpDesignSystem.PropsWithChildren<MuiPaperProps & {}>;

export const Paper = forwardRef<HTMLDivElement, PaperProps>(({ dataTest, ...props }, ref) => (
  <MuiPaper data-test={dataTest} ref={ref} {...props} />
));
